<template>
  <div id="app">
    <app-header v-show="!hideHeaderList.includes($route.name)"/>
    <router-view />
  </div>
</template>
<script>
import appHeader from '@/components/Header.vue'
export default {
  components: {
    appHeader
  },
  data() {
    return {
      hideHeaderList: []
    }
  }
}
</script>
<style>
@import url('./reset.css');
</style>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
